(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bestseller-collection-sort"] && !Shopify.designMode) return;
  try {
    /* Bestseller Collection Sort - behavioural logic only, no markup is built here. */
  (function () {
    'use strict';

    /* ---------------------------------------------------------------------
       Theme selectors. Verify these against the live collection template.
       --------------------------------------------------------------------- */
    var ROOT_SELECTOR = '[data-bestseller-sort]';
    var FILTERS_ROOT_SELECTOR = '#bch-product-filters';
    var GRID_ID = 'product-grid';
    var GRID_FALLBACK_SELECTOR = '.ux-pc__grid';
    var GRID_ITEM_SELECTOR = 'li.grid__item';
    var CARD_WRAPPER_CLASS = 'product-card-wrapper';
    var FILTER_HIDDEN_CLASS = 'bch-filter-hidden';
    var CLEAR_ALL_SELECTOR = '.bch-pill--clear-all';
    var FILTER_ITEM_SELECTOR = '.bch-dropdown__item[data-category]:not([data-category="__sort"]), .bch-pill:not(.bch-pill--clear-all)';
    var SEARCH_INPUT_SELECTOR = '.bch-filters__search-input';
    var CARD_LINK_SELECTOR = '[id^="CardLink-"]';
    var PRODUCT_LINK_SELECTOR = 'a[href*="/products/"]';

    var SORT_CONTROL_POLL_INTERVAL = 50;
    var SORT_CONTROL_POLL_TIMEOUT = 5000;

    function throttle(fn, wait) {
      var last = 0;
      var timer = null;
      return function () {
        var now = Date.now();
        var remaining = wait - (now - last);
        if (remaining <= 0) {
          if (timer) { clearTimeout(timer); timer = null; }
          last = now;
          fn();
        } else if (!timer) {
          timer = setTimeout(function () {
            timer = null;
            last = Date.now();
            fn();
          }, remaining);
        }
      };
    }

    function debounce(fn, wait) {
      var timer = null;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }

    function parseRankMap(value) {
      var map = {};
      if (!value) return map;
      value.split(',').forEach(function (pair) {
        if (!pair) return;
        var separator = pair.lastIndexOf(':');
        if (separator < 1) return;
        var key = pair.slice(0, separator).trim();
        var rank = parseFloat(pair.slice(separator + 1));
        if (key && isFinite(rank)) map[key] = rank;
      });
      return map;
    }

    function getGrid() {
      var byId = document.getElementById(GRID_ID);
      if (byId) return byId;

      var grids = document.querySelectorAll(GRID_FALLBACK_SELECTOR);
      if (!grids.length) return null;

      var filtersRoot = document.querySelector(FILTERS_ROOT_SELECTOR);
      if (!filtersRoot) return grids[0];

      for (var i = 0; i < grids.length; i++) {
        if (filtersRoot.compareDocumentPosition(grids[i]) & Node.DOCUMENT_POSITION_FOLLOWING) {
          return grids[i];
        }
      }
      return grids[0];
    }

    function getGridItems(grid) {
      var items = Array.prototype.slice.call(grid.querySelectorAll(GRID_ITEM_SELECTOR));
      if (items.length) return items;

      return Array.prototype.slice.call(grid.children).filter(function (el) {
        return el.classList.contains(CARD_WRAPPER_CLASS);
      });
    }

    function getProductIdFromItem(item) {
      var cardLink = item.querySelector(CARD_LINK_SELECTOR);
      if (!cardLink) return null;
      var match = /CardLink-.+-(\d+)$/.exec(cardLink.id);
      return match ? match[1] : null;
    }

    function getProductHandleFromItem(item) {
      var link = item.querySelector(PRODUCT_LINK_SELECTOR);
      if (!link) return null;
      var match = /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
      return match ? match[1] : null;
    }

    function init(root) {
      var sortValue = root.getAttribute('data-sort-value') || 'best-selling';
      var forceDefaultSort = root.getAttribute('data-force-default-sort') === 'true';
      var rankById = parseRankMap(root.getAttribute('data-ranks'));
      var rankByHandle = parseRankMap(root.getAttribute('data-rank-handles'));

      var sortItemSelector = '.bch-dropdown__item[data-category="__sort"][data-value="' + sortValue + '"]';
      var sortDrawerItemSelector = '.bch-sort-drawer-item[data-sort-value="' + sortValue + '"]';

      var observer = null;
      var isSorting = false;

      function isBestSellingActive() {
        return new URLSearchParams(window.location.search).get('sort_by') === sortValue;
      }

      function getRank(item) {
        var id = getProductIdFromItem(item);
        if (id && Object.prototype.hasOwnProperty.call(rankById, id)) return rankById[id];

        var handle = getProductHandleFromItem(item);
        if (handle && Object.prototype.hasOwnProperty.call(rankByHandle, handle)) return rankByHandle[handle];

        return Infinity;
      }

      function applyGridSort() {
        if (!isBestSellingActive() || isSorting) return;

        var grid = getGrid();
        if (!grid) return;

        var items = getGridItems(grid);
        if (!items.length) return;

        var sorted = items.slice().sort(function (a, b) {
          var aHidden = a.classList.contains(FILTER_HIDDEN_CLASS);
          var bHidden = b.classList.contains(FILTER_HIDDEN_CLASS);
          if (aHidden !== bHidden) return aHidden ? 1 : -1;
          return getRank(a) - getRank(b);
        });

        var orderChanged = sorted.some(function (el, index) {
          return el !== items[index];
        });

        if (!orderChanged) return;

        isSorting = true;
        if (observer) observer.disconnect();

        var fragment = document.createDocumentFragment();
        sorted.forEach(function (el) {
          var rank = getRank(el);
          if (isFinite(rank)) {
            el.setAttribute('data-bestseller-rank', String(rank));
          } else {
            el.removeAttribute('data-bestseller-rank');
          }
          fragment.appendChild(el);
        });
        grid.appendChild(fragment);

        if (observer) {
          observer.observe(grid, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
        }
        isSorting = false;
      }

      var scheduleSort = throttle(applyGridSort, 150);

      function observeGrid() {
        var grid = getGrid();
        if (!grid || observer) return;

        observer = new MutationObserver(scheduleSort);
        observer.observe(grid, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      function selectBestSellingSort(force) {
        var currentSort = new URLSearchParams(window.location.search).get('sort_by');
        if (!force && currentSort) return;

        var control = document.querySelector(sortItemSelector) || document.querySelector(sortDrawerItemSelector);
        if (control) {
          control.click();
          return;
        }

        if (force) return;

        var waited = 0;
        var poll = setInterval(function () {
          waited += SORT_CONTROL_POLL_INTERVAL;
          var el = document.querySelector(sortItemSelector) || document.querySelector(sortDrawerItemSelector);
          if (el) {
            clearInterval(poll);
            if (!new URLSearchParams(window.location.search).get('sort_by')) el.click();
          } else if (waited >= SORT_CONTROL_POLL_TIMEOUT) {
            clearInterval(poll);
          }
        }, SORT_CONTROL_POLL_INTERVAL);
      }

      function bindFilterControls() {
        var filtersRoot = document.querySelector(FILTERS_ROOT_SELECTOR);
        if (!filtersRoot) return;

        filtersRoot.addEventListener('click', function (event) {
          var target = event.target;
          if (!target || !target.closest) return;

          if (target.closest(CLEAR_ALL_SELECTOR)) {
            selectBestSellingSort(true);
            return;
          }

          if (target.closest(FILTER_ITEM_SELECTOR)) {
            setTimeout(scheduleSort, 0);
          }
        });

        var searchInput = filtersRoot.querySelector(SEARCH_INPUT_SELECTOR);
        if (searchInput) {
          searchInput.addEventListener('input', debounce(scheduleSort, 300));
        }
      }

      bindFilterControls();

      if (isBestSellingActive()) {
        applyGridSort();
        observeGrid();
      } else if (forceDefaultSort) {
        selectBestSellingSort(false);
      }

      window.addEventListener('popstate', function () {
        if (isBestSellingActive()) {
          observeGrid();
          scheduleSort();
        }
      });
    }

    function boot() {
      var root = document.querySelector(ROOT_SELECTOR);
      if (root) init(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["visual-menu-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('visual-menu-drawer')) {
    class VisualMenuDrawer extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.lastOpener = null;
        this.drawerDetails = null;
      }

      // Capture phase: runs before the theme's MenuDrawer listener on each button (global.js bindEvents), which would close the drawer.
      connectedCallback() {
        this.addEventListener('click', this.handleClick, true);
        this.drawerDetails = this.closest('#Details-menu-drawer-container') || this.closest('details');
        if (this.drawerDetails) {
          this.drawerDetails.addEventListener('toggle', this.handleDrawerToggle);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick, true);
        if (this.drawerDetails) {
          this.drawerDetails.removeEventListener('toggle', this.handleDrawerToggle);
        }
      }

      handleClick(event) {
        const backButton = event.target.closest('[data-visual-menu-back]');
        if (backButton) {
          event.preventDefault();
          event.stopPropagation();
          this.showView('', { restoreFocus: true });
          return;
        }

        const opener = event.target.closest('[data-visual-menu-open]');
        if (opener) {
          event.preventDefault();
          event.stopPropagation();
          this.showView(opener.dataset.visualMenuOpen, { opener: opener });
          return;
        }

        if (event.target.closest('[data-visual-menu-currency]')) {
          event.preventDefault();
          event.stopPropagation();
          this.openCountrySelector();
        }
      }

      // Return to the tile overview whenever the drawer closes.
      handleDrawerToggle() {
        if (!this.drawerDetails.open && this.hasAttribute('data-view')) {
          this.showView('');
        }
      }

      showView(view, options) {
        const settings = options || {};
        const panels = Array.from(this.querySelectorAll('[data-visual-menu-panel]'));
        const activePanel = view
          ? panels.find((panel) => panel.dataset.visualMenuPanel === view)
          : null;

        if (view && !activePanel) return;

        panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
        });

        const level1 = this.querySelector('[data-visual-menu-level1]');
        if (level1) level1.hidden = Boolean(activePanel);

        if (activePanel) {
          this.setAttribute('data-view', view);
          this.lastOpener = settings.opener || null;
        } else {
          this.removeAttribute('data-view');
        }

        const scroller = this.closest('.menu-drawer__navigation-container');
        if (scroller) scroller.scrollTop = 0;

        if (activePanel) {
          const panelBack = activePanel.querySelector('[data-visual-menu-back]');
          if (panelBack) panelBack.focus({ preventScroll: true });
        } else {
          if (settings.restoreFocus && this.lastOpener) {
            this.lastOpener.focus({ preventScroll: true });
          }
          this.lastOpener = null;
        }
      }

      // The currency pill opens the theme's own country selector, which stays in the drawer (visually collapsed).
      openCountrySelector() {
        const scope = this.closest('#menu-drawer') || document;
        const trigger =
          scope.querySelector('#HeaderCountryMobileForm .disclosure__button') ||
          scope.querySelector('localization-form .disclosure__button');
        if (trigger) trigger.click();
      }
    }

    customElements.define('visual-menu-drawer', VisualMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
